import React from 'react';

import Feed from '../Feed';
import { ArticleOrBriefing } from '../Feed/ArticleOrBriefingFeedItem';

interface SearchArticlesListProps {
  content: ArticleOrBriefing[];
}

const SearchArticlesList = ({ content }: SearchArticlesListProps) => {
  return <Feed articlesOrBriefings={content} useLargeImage />;
};

export default SearchArticlesList;
